module.exports = __webpack_public_path__ + "static/media/s3.1b5bc3d1.jpg";